export const applicationConstants = {
    yes: "YES",
    no: "NO",
    mediumDeviceWidth: 767,
    primary: "PRIMARY",
    coBorrower: "CO-BORROWER",
    contactUsNumber: '1-888-264-6843',
    totalSlides: 5,
    totalSlidesForCoBorrower: 6,
    en: 'en',
    QC: 'QC',
    declined: 'declined',
    pendingContact: 'Pending Contact',
    eidComplete: 'eIDComplete',
    addressSuccess: '',
    addressApartmentMiss: 39606,
    addressPartialMatch_1: 39602,
    addressPartialMatch_2: 39608,
    createProspectFailed: "Create Prospect failed",
    yesVal: "Y",
    noVal: "N",
    consentFailureCode: 102,
    selectedLiabilityCode: 'O',
    yesLiteral: "yes",
    noLiteral: "no",
    fixedRate: 'F',
    variableRate: 'V',
    cbFailure: '426',
    creditBureauNoHit: '421',
    RatingForTradesExclusion: '422',
    retailPublicRecordExclusion: '423',
    bankruptcyExclusion: '424',
    minimumBureauScoreExclusion: '425',
    applicantReportedDeceased: '428',
    unknownException: '999'
}
export enum PROGRESS_PERCENTAGE {
    CO_APPLICANT_SELECTION = 10,
    CIBC_RELATION = 20,
    PERSONAL_INFO_PRIMARY_EXISTING = 40,
    NEW_CUSTOMER_TELL_US_ABOUT_YOURSELF_PRIMARY = 30,
    NEW_CUSTOMER_CURRENT_ADDRESS_PRIMARY = 30,
    NEW_CUSTOMER_CONTACT_DETAILS_PRIMARY = 30,
    SUMMARY_AND_VERIFICATION_PRIMARY = 40,
    CONSENT_PRIMARY = 40,
    VERIFY_YOUR_1_IDENTITY_PRIMARY = 55,
    NEW_CUSTOMER_1_TELL_US_ABOUT_YOURSELF_PRIMARY = 30,
    NEW_CUSTOMER_1_CURRENT_ADDRESS_PRIMARY = 50,
    NEW_CUSTOMER_1_CONTACT_DETAILS_PRIMARY = 40,
    SUMMARY_AND_1_VERIFICATION_PRIMARY = 55,
    CONSENT_PRIMARY_1 = 60,
    VERIFY_YOUR_IDENTITY_PRIMARY = 70,
    COAPPLICANT_OLB_REDIRECTION = 50,
    CIBC_RELATIONSHIP_2_CUSTOMER = 60,
    PERSONAL_INFO_PRIMARY_EXISTING_2_CUSTOMER = 80,
    NEW_CUSTOMER_TELL_US_ABOUT_YOURSELF_2_CUSTOMER = 65,
    NEW_CUSTOMER_CURRENT_ADDRESS_2_CUSTOMER = 75,
    NEW_CUSTOMER_CONTACT_DETAILS_2_CUSTOMER = 70,
    SUMMARY_AND_VERIFICATION_PRIMARY_2_CUSTOMER = 80,
    CONSENT_PRIMARY_2_CUSTOMER = 85,
    VERIFY_YOUR_IDENTITY_PRIMARY_2_CUSTOMER = 90,
    TIME_TO_PURCHASE_2_CUSTOMER = 92,
    EARNING_2_CUSTOMER = 95,
    EARNING_1_CUSTOMER = 80,
    PERSONAL_INFO_CO_APPLICANT = 70,
    CONSENT_CO_APPLICANT = 85,
    CONCENT_FIRST = 60,
    TIME_TO_PURCHASE = 75,
    EARNING = 80,
    EARNING_CO_APPLICANT = 95,
    RESULTS = 100,
    REQUEST_CALLBACK = 100,
    CONCENT_FIRST_APPLICANT = 50,
    ONLINE_RATE = 90,

    // New Progress Indicator Values

    BUYING_WITH_SOMEONE = 10,
    SWITCHING_WITH_SOMEONE = 10,
    NEWCUSTOMER_1_NAME_DOB = 25,
    NEWCUSTOMER1_AND_EXISTINGCUSTOMER1_NAME_DOB = 35,
    JOINT_NEWCUSTOMERS_2_NAME_DOB = 30,
    NEWCUSTOMER_1_ADDRESSINFO = 30,
    NEWCUSTOMER_1_AND_EXISTINGCUSTOMER1_ADDRESSINFO = 40,
    JOINT_NEWCUSTOMERS_2_ADDRESSINFO = 40,
    NEWCUSTOMER_1_PHONE = 40,
    NEWCUSTOMER_1_AND_EXISTINGCUSTOMER1_PHONE = 50,
    JOINT_NEWCUSTOMERS_2_PHONE = 50,
    NEWCUSTOMER_1_PHONE_SWITCH = 35,
    NEWCUSTOMER_1_AND_EXISTINGCUSTOMER1_PHONE_SWITCH = 45,
    EXISTINGCUSTOMER_1_PERSONALINFO_CLIENT = 50,
    EXISTINGCUSTOMER_1_NEWCUSTOMER_1_PERSONALINFO_CLIENT = 25,
    JOINT_EXISTINGCUSTOMERS_2_PERSONALINFO_CLIENT = 60,
    EXISTINGCUSTOMER_1_PERSONALINFO_CLIENT_SWITCH = 30,
    JOINT_EXISTINGCUSTOMERS_2_PERSONALINFO_CLIENT_SWITCH = 40,
    NEWCUSTOMER_1_PERSONALINFO = 50,
    NEWCUSTOMER_1_EXISTINGCUSTOMER1_PERSONALINFO = 60,
    JOINT_NEWCUSTOMERS_2_PERSONALINFO = 60,
    NEWCUSTOMER_1_PERSONALINFO_SWITCH = 40,
    NEWCUSTOMER_1_EXISTINGCUSTOMER_1_PERSONALINFO_SWITCH = 50,
    JOINT_NEWCUSTOMERS_2_PERSONALINFO_SWITCH = 55,
    GROSS_INCOME = 70,
    NEW_CUSTOMER_1_OR_EXISTING_CUSTOMERS_2_GROSS_INCOME_SWITCH = 50,
    NEW_CUSTOMERS_2_OR_NEW_CUSTOMER_1_EXISTING_CUSTOMER_1_GROSS_INCOME_SWITCH = 60,
    EXISTING_CUSTOMER_1_GROSS_INCOME_SWITCH = 40,
    PLAN_TO_BUY = 80,
    TERMS_AND_CONDITIONS = 90,
    EXISTING_CUSTOMERS_2_OR_NEW_CUSTOMER_1_OR_EXISTING_CUSTOMER_1_TERMS_AND_CONDITIONS_SWITCH = 60,
    EXISTING_CUSTOMER_1_AND_NEW_CUSTOMER_1_OR_NEW_CUSTOMERS_2_TERMS_AND_CONDITIONS_SWITCH = 65,
    NEWCUSTOMER_1_OR_NEW_CUSTOMER_1_AND_EXISTING_CUSTOMER_1_OR_EXISTING_CUSTOMERS_2_OR_NEW_CUSTOMERS_2_CHOOSE_MORTGAGE_SWITCH = 70,
    EXISTING_CUSTOMER_1_CHOOSE_MORTGAGE_SWITCH = 65,
    NEWCUSTOMER_1_OR_NEW_CUSTOMER_1_AND_EXISTING_CUSTOMER_1_OR_EXISTING_CUSTOMERS_2_OR_NEW_CUSTOMERS_2_ESTIMATED_VALUE_SWITCH = 80,
    EXISTING_CUSTOMER_1_ESTIMATED_VALUE_SWITCH = 75,
    NEWCUSTOMER_1_OR_NEW_CUSTOMER_1_AND_EXISTING_CUSTOMER_1_OR_EXISTING_CUSTOMERS_2_OR_NEW_CUSTOMERS_2_MATURITY_IN_4_MONTHS_SWITCH = 85,
    EXISTING_CUSTOMER_1_MATURITY_IN_4_MONTHS_SWITCH = 80,
    ONLINE_EXCLUSIVE_RATE_OFFER = 90,
}

export const oneCustomerFlow = {

}

export const nameInSessionStorage = {
    TRANSACTION_ID: "transactionid"
}
export const sessionConstants = {
    IDEALTIME: (480),//480=8*60 in minutes
    TIMEOUT: (120),//600  10*60 in minutes
    MAXIDELTIME: (35 * 60)//210,000 35*6000 in minutes
}

export const encodeConst = {
    key: "ENCODEAUTHPREQUALCIBC",
    yes: "yes"
}

export const redirects = {
    REQUESTTOMA_EN: 'https://www.cibc.com/en/personal-banking/mortgages/request-a-call.html',
    REQUESTTOMA_FR: 'https://www.cibc.com/fr/personal-banking/mortgages/request-a-call.html',
    FIND_ADVISOR_EN: 'https://advisor.cibc.com/mortgage',
    FIND_ADVISOR_FR:'https://advisor.cibc.com/fr/mortgage'
}
export const userRoles={
MSA:"MSA"
}